import { FetchDataFn } from '../react/useFetch';
import { GetParams, Pagination } from '../types';

const MAX_PER_PAGE = 100;

export function loadAllPages<P extends GetParams, D extends any[]>(fetchDataFn: FetchDataFn<P, D>): FetchDataFn<P, D> {
  return async (params: P = {} as P): Promise<[D, Pagination | null]> => {
    let currentPage = 1;
    let lastPage = 1;
    let records: any[] = [];
    do {
      const [data, pagination] = await fetchDataFn({ ...params, page: currentPage, per_page: MAX_PER_PAGE });

      if (data) {
        records = records.concat(data);
      }
      if (pagination) {
        currentPage++;
        lastPage = pagination.total_pages;
      } else {
        lastPage = currentPage;
      }
    } while (currentPage <= lastPage);
    return [records as D, null];
  };
}
